export const registrationInfos = {
    contribution: 'You will receive an email confirming receipt of each contribution made to aviowiki data.',
    publish:
        'You will receive an email when each contribution has been verified and published by the aviowiki data team.',
};
